var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7611 11.318L12.7612 11.3181C13.0594 11.6006 13.5409 11.6006 13.8392 11.3181C14.1405 11.0326 14.1405 10.5674 13.8392 10.2819L10.0392 6.68193C9.74089 6.39937 9.25942 6.39937 8.96116 6.68193L5.16116 10.2819C4.85982 10.5674 4.85982 11.0326 5.16116 11.3181C5.45942 11.6006 5.94089 11.6006 6.23916 11.3181L9.50194 8.22702L12.7611 11.318Z",
    fill: "#0D80FF",
    stroke: "#0D80FF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevronUp.2e75cc21505145b7c43ae3eb26c8b216.svg";
export { ForwardRef as ReactComponent };